// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"f7c36061","20":"8aba97e3","47":"99879afe","86":"82f9dbaf","90":"d88d4ffa","170":"c2a5abcb","248":"6b5b2e5f","488":"fbe23901","820":"187d8dac","878":"550b5d5d","906":"c9e3dcf4","921":"8ea59342"}[chunkId] + ".chunk.js";
};